import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast } from "react-toastify";
import axios from "axios";

export const TopPicks = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const scrollRef = useRef(null); // 🔥 added
  const headRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        // 🔹 Fetch Categories first
        const catRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );

        if (catRes.data.status === true || catRes.data.status === "true") {
          setCategories(catRes.data.row);
        }

        // 🔹 Now fetch products
        const prodRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
        );

        if (prodRes.data.status === true || prodRes.data.status === "true") {
          const filtered = prodRes.data.data.filter(
            (item) => item.product_status === "Top Pick of the sale" &&
                      item.admin_approval === "approval" &&
                      item.paid_approval === "yes"
          );
          setProducts(filtered);
        } else {
          toast.error("Failed to fetch product list!");
        }
      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      }
    };

    fetchAll();
  }, []);

  // ── Intersection Observer ──
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (headRef.current) observer.observe(headRef.current);
    cardRefs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, [products]); // re-run after products load

  // Map category_id → category_name
  const getCategoryName = (catId) => {
    const found = categories.find((c) => c.category_id === catId);
    return found ? found.category_name : "Unknown";
  };

  // 🔥 Scroll functions
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <div className="container my-4 bg-white">

      {/* Header */}
      <div
        className="d-flex justify-content-between align-items-center tp-head"
        ref={headRef}
      >
        <h3 className="fw-bold p-1">Top picks of the sale</h3>
        <Link
          to="/products"
          state={{ categoryId: 2 }} // 🔥 Electronics ID
          className="text-decoration-none"
          style={{ color: "#fc92cc" }}
        >
          View All <i className="bi bi-chevron-right"></i>
        </Link>
      </div>

      {/* 🔥 Wrapper for arrows */}
      <div className="position-relative">

        {/* 🔥 Prev Button */}
        <button onClick={scrollLeft} className="scroll-btn left">‹</button>

        <div
          ref={scrollRef}
          className="d-flex overflow-auto gap-3 px-2 top-picks-scroll"
        >
          {products.map((product, index) => (
            <div
              key={product.id}
              ref={(el) => (cardRefs.current[index] = el)}
              className="col-lg-2 col-md-3 col-sm-6 col-6 mb-4 d-flex flex-shrink-0 tp-card"
              style={{ width: "230px", "--delay": `${index * 70}ms` }} // 🔥 important for horizontal scroll
            >
              <div className="card flex-fill h-100 shadow-sm border rounded-3">
                <img
                  src={`https://cyberathon.com/multivendor/${product.multi_image?.[0]}`}
                  className="card-img-top img-fluid"
                  alt={product.product_name}
                />
                <div className="card-body">
                  <p className="product-title mb-1">
                    {product.product_name.split(" ").slice(0, 2).join(" ")}
                  </p>

                {/* 🔥 Display category name here */}
                {/* <p className="text-muted small mb-1">
                  {getCategoryName(product.category_id)}
                </p> */}

                {/* <div className="d-flex align-items-center mb-2">
                  <span className="fw-semibold me-1">
                    {product.rating?.rating ?? "4.5"}
                  </span>
                  <span style={{ color: "#f5c518" }}>★</span>
                  <span className="text-dark ms-1 small">
                    | {product.rating?.rating ?? 100} Ratings
                  </span>
                </div> */}

                {/* <p className="fw-semibold mb-1">{product.status}</p> */}

                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <p className="price-new mb-0">₹{product.current_price}</p>

                    <small className="price-old text-muted text-decoration-line-through">
                      ₹{product.old_price}
                    </small>

                    {product.discount && (
                      <small className="fw-semibold">
                        ({product.discount}% OFF)
                      </small>
                    )}
                  </div>

                <div className="mt-2 text-center">
                  <Link to={`/model/${product.product_id}`}>
                    <button type="submit" className="Addto-cart">Add to bag</button>
                  </Link>
                </div>

                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 🔥 Next Button */}
        <button onClick={scrollRight} className="scroll-btn right">›</button>

      </div>
    </div>
  );
};